export default __webpack_public_path__ + "static/media/14_2.dd46418c.jpg";